import NodeCapture from "../../../../contents/docs/libraries/node/_snippets/capture.mdx";
import PythonCapture from "../../../../contents/docs/libraries/python/_snippets/capture.mdx";
import PHPCapture from "../../../../contents/docs/libraries/php/_snippets/capture.mdx";
import GoCapture from "../../../../contents/docs/libraries/go/_snippets/capture.mdx";
import RubyCapture from "../../../../contents/docs/libraries/ruby/_snippets/capture.mdx";
import CURLCapture from "../../../../contents/docs/libraries/curl/_snippets/capture.mdx";
import Tab from "components/Tab";
import NodeIdentify from "../../../../contents/docs/libraries/node/_snippets/identify.mdx";
import PythonIdentify from "../../../../contents/docs/libraries/python/_snippets/identify.mdx";
import PHPIdentify from "../../../../contents/docs/libraries/php/_snippets/identify.mdx";
import GoIdentify from "../../../../contents/docs/libraries/go/_snippets/identify.mdx";
import RubyIdentify from "../../../../contents/docs/libraries/ruby/_snippets/identify.mdx";
import CURLIdentify from "../../../../contents/docs/libraries/curl/_snippets/identify.mdx";
import * as React from 'react';
export default {
  NodeCapture,
  PythonCapture,
  PHPCapture,
  GoCapture,
  RubyCapture,
  CURLCapture,
  Tab,
  NodeIdentify,
  PythonIdentify,
  PHPIdentify,
  GoIdentify,
  RubyIdentify,
  CURLIdentify,
  React
};